module.exports = __webpack_public_path__ + "img/ff01d.72d113d1.svg";